import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Alert as MuiAlert, Box, Collapse } from '@mui/material';
import { removeNotification } from '../../store/notificationSlice';

const Notification = ({ notification, onClose }) => {
    const [open, setOpen] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            handleClose();
        }, 6000);

        return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        setOpen(false);
        // Allow time for collapse animation before calling parent onClose
        setTimeout(() => {
            onClose();
        }, 300); 
    };

    return (
        <Collapse in={open}>
            <MuiAlert
                onClose={handleClose}
                severity={notification.options?.variant || 'info'}
                sx={{ mb: 1, width: '100%' }}
                elevation={6}
                variant="filled"
            >
                {notification.message}
            </MuiAlert>
        </Collapse>
    );
};

const Notifier = () => {
    const dispatch = useDispatch();
    const notifications = useSelector((state) => state.notifications.notifications);

    const handleClose = (key) => {
        dispatch(removeNotification(key));
    };

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: '10px',
                right: '50%',
                transform: 'translateX(50%)',
                zIndex: 9999,
                width: 'auto',
                minWidth: '300px',
            }}
        >
            {notifications.map((notification) => (
                <Notification
                    key={notification.key}
                    notification={notification}
                    onClose={() => handleClose(notification.key)}
                />
            ))}
        </Box>
    );
};

export default Notifier; 